import { AxiosResponse } from 'axios'
import { http } from '../../../utils'

export function fetchSoftwareInvoicePdf(id: number) {
  const url = `/software_invoice/pvt/pdf?invoice_id=${id}`
  return http.get(url).then((response: AxiosResponse) => response.data)
}